module.exports = new __parcel__URL__("model-photo-card-tips-icon.1273b08b.png").toString();